import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "base-modal" }
const _hoisted_2 = { class: "base-modal--close" }
const _hoisted_3 = { class: "base-modal--title" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "base-modal--subtitle"
}
const _hoisted_6 = { class: "caption-medium color-grey-light" }
const _hoisted_7 = { class: "base-modal--slot" }
const _hoisted_8 = { class: "base-modal--actions" }
const _hoisted_9 = { class: "base-modal--main-btn" }
const _hoisted_10 = { class: "base-modal--color-secondary-btn" }
const _hoisted_11 = {
  key: 1,
  class: "base-modal--icon color-white"
}

import { computed } from "vue";
import BaseButton from "@/components/base/BaseButton.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import { PropType } from "@vue/runtime-core";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
  title: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: false,
  },
  mainBtnTitle: {
    type: String,
    required: true,
  },
  mainBtnLoading: {
    type: Boolean,
    default: false,
  },
  secondaryBtnTitle: {
    type: String,
    required: false,
  },
  secondaryBtnLoading: {
    type: Boolean,
    default: false,
  },
  status: {
    type: String as PropType<"success" | "default" | "error">,
    default: "default",
  },
},
  emits: ["action", "secondary-action", "close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isResultStatus = computed(() =>
  ["error", "success"].includes(props.status)
);

const emitAction = () => {
  emit("action");
};

const emitSecondaryAction = () => {
  emit("secondary-action");
};

const emitClose = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    appear: "",
    name: "modal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["base-modal--window", __props.status])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(BaseFigureForIcon, {
              icon: "close",
              color: "white",
              size: "medium",
              "is-button": "",
              onClick: emitClose
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", {
              class: _normalizeClass(["h1", { 'color-white': isResultStatus.value }]),
              innerHTML: __props.title
            }, null, 10, _hoisted_4)
          ]),
          (__props.text)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(__props.text), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(BaseButton, {
                title: __props.mainBtnTitle,
                onClick: emitAction,
                loading: __props.mainBtnLoading,
                color: isResultStatus.value ? 'white' : 'primary'
              }, null, 8, ["title", "loading", "color"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (__props.secondaryBtnTitle)
                ? (_openBlock(), _createBlock(BaseButton, {
                    key: 0,
                    title: __props.secondaryBtnTitle,
                    color: 'grey',
                    onClick: emitSecondaryAction,
                    loading: __props.secondaryBtnLoading
                  }, null, 8, ["title", "loading"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (isResultStatus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (__props.status === 'success')
                  ? (_openBlock(), _createBlock(BaseIcon, {
                      key: 0,
                      name: "check-success",
                      folder: "display",
                      class: "icon-check"
                    }))
                  : (__props.status === 'error')
                    ? (_openBlock(), _createBlock(BaseIcon, {
                        key: 1,
                        name: "close",
                        folder: "display",
                        class: "icon-check"
                      }))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _: 3
  }))
}
}

})